import React from 'react';
import { ArrowRight } from 'lucide-react';

const NextSteps = () => {
  return (
    <section className="relative py-20 lg:py-28 bg-[#0d274d] text-white overflow-hidden">
      <img
        src="https://www.cisco.com/content/dam/cisco-cdc/site/images/backgrounds/homepage/endcap-gradient.png"
        aria-hidden
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-70 pointer-events-none"
      />
      <div className="relative max-w-5xl mx-auto px-4 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-10">Take your next steps</h2>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <a
            href="#"
            className="inline-flex items-center justify-center gap-2 bg-white text-[#0d274d] hover:bg-[#00bceb] hover:text-white transition-colors px-8 py-3 font-semibold"
          >
            Explore trials and demos
            <ArrowRight className="w-4 h-4" />
          </a>
          <a
            href="#"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#0d274d] transition-colors px-8 py-3 font-semibold"
          >
            Discover buying options
            <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default NextSteps;
